/**
 * set scroll position based on active item
 */
$.fn.visibleInParent = function() {
	var $this = $(this);
	var $parent = $this.parent();
	var eW = $this.outerWidth(true); // elem width
	var pW = $parent.innerWidth(); // parent width
	var pCW = $parent[0].scrollWidth; // parent content width
	var oL = $this.position().left; // offset left
	var sL = 0;

	if(oL > pW - 50 || oL < 50){ // if not in parent view
		oL = Math.abs(oL);
		sL = pCW - oL - pW - pW/2 + eW/2;

		$parent.scrollLeft(sL);
	}
}


$(function() {
	var $el = $('.visible-in-parent .current');

  if($el.length > 0){
   $el.visibleInParent();
	}
});